import { render, staticRenderFns } from "./ViewSimulator.vue?vue&type=template&id=d6bb2d32&scoped=true&"
import script from "./ViewSimulator.vue?vue&type=script&lang=ts&"
export * from "./ViewSimulator.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSimulator.vue?vue&type=style&index=0&id=d6bb2d32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bb2d32",
  null
  
)

export default component.exports